export default __webpack_public_path__ + "static/media/sentencing.1c77aca3.png";